<template>
    <div class='caseAnalysis_wrap'>
        <el-row>
            <!-- 导航栏内容 -->
            <el-col :span='3'>
                <div class='nav_wrap'>
                    <div class='nav_title'>
                        案例系统
                    </div>
                    <div class='nav_list'>
                        <div @click='changeNav(0)' :style="activeIndex == 0 ? 'background:#425FC6' :''"
                             class='list_item'>不限分类
                        </div>
                        <div @click='changeNav(item.id)' :style="activeIndex == item.id ? 'background:#425FC6' :''"
                             class='list_item' v-for='item in navList' :key='item.id' :index='item.id'>
                            {{item.categoryName}}
                        </div>
                    </div>
                </div>
            </el-col>
            <!-- 右侧内容 -->
            <el-col :span="21">
                <div class="content_wrap">
                    <!-- 筛选内容 -->
                    <div class="flex-between case_top">
                        <div class="button_wrap">
                            <el-button  type="primary" @click="sortType = 0,getTable()">发布日期</el-button>
                            <el-button  type="primary" @click="sortType = 1,getTable()">阅读量</el-button>
                            <el-button  type="primary" @click="sortType = 2,getTable()">点赞量</el-button>
                        </div>
                        <div class="input_wrap">
                            <el-input @keyup.enter.native='getTable()' placeholder='关键字' prefix-icon='el-icon-search'
                                      v-model='searchKey'></el-input>
                            <el-button type="primary" @click="getTable()">搜索</el-button>
                        </div>
                    </div>
                    <!-- 表单内容 -->
                    <div class="case_wrap">
                        <div @click="toNetwork(item.caseUrl,item.id,item.notAvailable)" :class="['case_item','flex-between',{'notAvailable_wrap':item.notAvailable}]" class="" v-for="item in dataList" :key="item.id">
                            <div class="img_wrap">
                                <img :src="item.imageUrl">
                            </div>
                            <div class="text_wrap">
                                <div class="title">{{item.caseTitle}}</div>
                                <div class="brief">简介：{{item.caseSummary}}</div>
                                <!-- <div class="language">语言：{{item.programLanguage}}</div> -->
                            </div>
                            <div v-if="item.notAvailable" class="notAvailable_text">
                                <div>待开放</div>
                            </div>
                            <div v-else class="info_wrap">
                                <div class="flex-between">
                                    <div>类型：{{item.categoryName}}</div>
                                    <div>{{item.createTime.substr(0,10)}}</div>
                                </div>
                                <div class=" flex-between">
                                    <div></div>
                                    <div class="icon_wrap flex-between">
                                        <div><i class="iconfont icon-yanjing">&nbsp;{{item.browseNum}}</i> </div>
                                        <div><i class="iconfont icon-dianzan" @click.stop="toLike(item.id)" :style="item.isLike == 0 ? '':'color:#002D72'">&nbsp;{{item.likeNum}}</i> </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class='page_wrap'>
                        <el-pagination layout='prev, pager, next' :page-size='4' @current-change='getTable'
                                       :current-page.sync='pages.currentPage' :total='pages.totals'></el-pagination>
                    </div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import { addPageView, caseGiveLike, queryCaseAnalysis, queryCaseCategory } from '../../utils/api';

export default {
    data() {
        return {
            searchKey: '',
            activeIndex: 0,
            navList: [],
            dataList: [],
            pages: {
                currentPage: 1,
                totals: 1
            },
            sortType: 0
        };
    },
    created() {
        this.getTable();
        this.getCategory();
    },
    methods: {
        //获取导航栏标题
        getCategory() {
            queryCaseCategory().then(res => {
                this.navList = res.data;
            }).catch(err => {
            });
        },

        //新窗口打开url
        toNetwork(url, id, available) {
            if (available) return this.$message.error('本栏目暂未开放！！');
            addPageView({ caseId: id }).then(res => {
            }).catch(err => {
            });
            this.getTable();
                window.open(url,'_blank')
            },

            //给案例分析点赞
            toLike(id){
                caseGiveLike({ caseId: id }).then(res => {
                    this.getTable();
                }).catch(err=>{})
            },

            //获取表单数据
            getTable(){
                let params = {
                    keyword:this.searchKey,
                    page:this.pages.currentPage,
                    size:4,
                    categoryId:this.activeIndex,
                    sortType:this.sortType
                }
                queryCaseAnalysis(params).then(res => {
                    this.dataList = res.data.list;
                    this.pages.totals = res.data.totalCount;
                }).catch(err => {
                });
            },

        //切换导航栏
        changeNav(id) {
            this.activeIndex = id;
            this.getTable();
        }
    }
}
</script>
<style lang="scss" scoped>

/deep/li{
    background: none;
}
.page_wrap{
    height: 60px;
    line-height: 60px;
    margin-top: 30px;
    text-align: center;
}
.case_wrap{
    .case_item{
        box-sizing: border-box;
        padding: 20px 35px;
        background: white;
        margin-top: 15px;
    }

    .case_item:hover{
        // opacity: 0.9;
        background: #FAFAFF;
        cursor: pointer;
    }
    // height: 200px;
    .img_wrap{
        width: 15%;
        img{
            width: 100%;
        }
        // background: blue;
    }
    .text_wrap{
        box-sizing: border-box;
        padding-left: 30px;
        width: 67%;
        color: #5A5A5A;
        .title{
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            font-size: 23px;
            min-height: 70px;
            color: #5277F7;
        }
        .brief,.language{
            min-height: 35px;
            line-height: 1.5;
            // line-height: 35px;
        }
    }
    .info_wrap{
        width: 23%;
        box-sizing: border-box;
        color: #5A5A5A;
        padding: 10px 0px;
        min-height: 120px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .icon_wrap{
            width: 120px;
        }
    }
    .notAvailable_text{
        width: 23%;
        display: flex;
        justify-content: flex-end;
        font-size: 22px;
        align-items: center;
    }
    .notAvailable_wrap{
        color: #A1A1A1;
        .title{
            color: #A1A1A1;
        }
        .brief{
            color: #A1A1A1;
        }
    }
}
.caseAnalysis_wrap{
    width: 100%;
    // height: 100vh;
    background: #F3F6FF;
}
.nav_wrap{
    width: 100%;

    height:calc(100vh - 40px) ;
    background: #5277F7;
    color: white;
    .nav_title{
        height: 120px;
        font-weight: 600;
        line-height: 120px;
        text-align: center;
        letter-spacing: 2px;
        font-size: 35px;
        background: #6387FF;
        border-bottom: 2px solid #F2F5FF;
    }
    .nav_list{
        box-sizing: border-box;
        margin-top: 20px;
        .list_item{
            height: 60px;
            line-height: 60px;
            width: 100%;
            font-size: 20px;
            text-align: center;
            letter-spacing: 1px;
        }
        .list_item:hover{
            background: #425FC6;
            cursor: pointer;
        }
        // padding: 20px;
    }
}
.content_wrap{
    box-sizing: border-box;
    padding: 10px 100px;
    .case_top{
        height: 60px;
        .button_wrap{
            display: flex;
            width: 350px;
        }
        .input_wrap{
            display: flex;
            width: 250px;
            height: 40px;
        }
    }
}
</style>
